<template>
    <div class="body">
        <div class="activity">
            <img src="../assets/AlconForesight2025.png" alt="">
        </div>
        <div class="activity">
            <a class="button" @click="goToPage('/alcon/froms')">Click to Register</a>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'alconPage',
    data() {
        return {
        };
    },
    methods: {
        goToPage(links: string) {
            if (!links) return;
            this.$router.push(links); // 路径跳转
            // 或 this.$router.push({ name: 'routeName' }); // 命名路由
        }
    },
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.body {
    width: 100%;
}

.activity {
    width: 100%;
    font-size: 30px;
}

.activity img {
    width: 100%;
}

.button {
    width: 350px;
    height: 60px;
    background-color: #0161b7;
    border: none;
    color: white;
    text-align: center;
    line-height: 60px;
    text-decoration: none;
    display: inline-block;
    font-size: 40px;
    cursor: pointer;
    border-radius: 10px;
    margin-top: 5%;
}

.button:hover {
    background-color: #00419c;
}


@media (max-width: 1200px) {
    .button {
        width: 350px;
        height: 60px;
        line-height: 60px;
        font-size: 40px;
    }
}

@media (max-width: 760px) {
    .button {
        width: 200px;
        height: 40px;
        line-height: 40px;
        font-size: 20px;
    }
}
</style>
